import { render } from "./ClientVentasPedidos.vue?vue&type=template&id=64fe6ad7&scoped=true"
import script from "./ClientVentasPedidos.vue?vue&type=script&lang=js"
export * from "./ClientVentasPedidos.vue?vue&type=script&lang=js"

import "./ClientVentasPedidos.vue?vue&type=style&index=0&id=64fe6ad7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fe6ad7"]])

export default __exports__